import { useState } from "react";

interface IHookParams {
    isSubmitted: boolean;
    withSuccessView: boolean;
    onSubmit: VoidFunction;
}

interface IHookValue {
    isSuccessViewVisible: boolean;
    onButtonClick: VoidFunction;
}

export const useUpgradeBannerSubmit = ({ isSubmitted, withSuccessView, onSubmit }: IHookParams): IHookValue => {
    const [isSuccessViewVisible, setIsSuccessViewVisible] = useState<boolean>(isSubmitted);

    const onButtonClick = () => {
        if (withSuccessView) {
            setIsSuccessViewVisible(true);
        }

        onSubmit();
    };

    return { isSuccessViewVisible, onButtonClick };
};
